// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"f4b5057b","49":"5d64d223","403":"4365c7c5","453":"a4bfb56c","667":"2d30aa94","801":"1d6546c3","990":"bed7c0f2"}[chunkId] + ".chunk.js";
};